import { Input, Text } from "@mantine/core";
import { Fragment } from "react";
import type { Control, FieldErrors, UseFormRegister } from "react-hook-form";
import Select from "src/components/shared/_FormInputs/Select";
import { InputStyledWrapper } from "src/styled/UserForm.styled";

import { IGenericLoginForm } from "../GenericLogins.types";
import { logoutTimes } from "./GenericLoginEdit.utils";

interface Props {
  register: UseFormRegister<IGenericLoginForm>;
  control: Control<IGenericLoginForm>;
  errors: FieldErrors<IGenericLoginForm>;
  isNew: boolean | undefined;
}
const GenericLoginDetails = ({ register, errors, isNew, control }: Props) => {
  return (
    <Fragment>
      <InputStyledWrapper mb={30}>
        <Text size={"sm"}>Name</Text>
        <Input
          w={"50%"}
          {...register("name", { required: true })}
          error={!!errors?.name}
        />
      </InputStyledWrapper>
      <InputStyledWrapper mb={30}>
        <Text size={"sm"}>Email</Text>
        <Input
          w={"50%"}
          {...register("email", { required: true })}
          error={!!errors?.email}
          autoComplete="new-password"
          data-form-type="other"
        />
      </InputStyledWrapper>
      <InputStyledWrapper mb={30}>
        <Text size={"sm"}>Logout time</Text>
        <Select
          name="logout"
          control={control}
          w={"50%"}
          data={logoutTimes}
          required
        />
      </InputStyledWrapper>
      <InputStyledWrapper mb={30}>
        <Text size={"sm"}>Password</Text>
        <Input
          w={"50%"}
          {...register("pass", { required: isNew })}
          error={!!errors?.pass}
          type="password"
          autoComplete="new-password"
          data-form-type="other"
        />
      </InputStyledWrapper>
    </Fragment>
  );
};
export default GenericLoginDetails;
